<script setup lang="ts">
  import { VideoState } from '@/types/VideoState';
  import { computed } from 'vue';

  const props = defineProps<{
    state: VideoState;
  }>();

  const variant = computed(() => {
    switch (props.state) {
      case VideoState.NeverConnected:
      case VideoState.Disconnected:
        return 'danger';
      case VideoState.Connecting:
        return 'primary';
      case VideoState.Connected:
        return 'success';
      case VideoState.Paused:
        return 'primary';
      case VideoState.Failed:
      case VideoState.Closed:
        return 'danger';
      default:
        return 'primary';
    }
  });
</script>

<template>
  <span class="video-state-dot" :class="`video-state-dot--${variant}`"></span>
</template>

<style scoped>
.video-state-dot {
  display: block;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.video-state-dot--primary {
  background-color: var(--color-btn-dark-bg);
}

.video-state-dot--success {
  background-color: var(--color-btn-active-bg);
}

.video-state-dot--danger {
  background-color: var(--color-btn-cancel-bg);
}
</style>
